import React from "react"
import { SectionProps } from "../section-loader"
import { IAllNews, ISlider } from "../../../gatsby-graphql"
import { VideoWrapper } from "./full-width-video-elements"

interface FullWidthVideoProps extends SectionProps {
  data: {
    videoUrl: string
    width: number
    height: number
    title?: string
  }
}

const FullWidthVideo = ({ data }: FullWidthVideoProps) => {
  const width = data.width || 560;
  const height = data.height || 315;
  return (
    <VideoWrapper width={width} height={height}>
      <iframe
        width={width}
        height={height}
        src={data.videoUrl}
        title={data.title}
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      />
    </VideoWrapper>
  );
}

export default FullWidthVideo
